import { Dialog, Divider, Stack, Button } from "@mui/material";
import { ReactNode } from "react";
import pxToRem from "../../helpers/pxToRem";
import { DestructiveButton, PrimaryButton } from "../Button";
import styles from './Dialog.module.scss';

interface IGeneralDialog extends ISuccessDialog {
    children?: ReactNode;
    handleCancel?: ()=>void;
    destructive?: boolean;
    loading?: boolean;
  }
  export const GeneralDialog = (props: IGeneralDialog) => {
  
    return (
      <Dialog open={props.visible} onClose={() => {}}>
        <Stack className={styles.deleteDialogContent} sx={{
        width: pxToRem(600), maxWidth: '90%', alignSelf:'center'
      }}>
          {props.title?<h5>{props.title}</h5>:null}
          {props.desc ? <p>{props.desc}</p> : null}
          {props.children ? props.children : null}
        </Stack>
        <Stack className={styles.deleteDialogAction}>
          <Divider flexItem />
          <Stack sx={{alignItems:'center', width: '100%'}}>
            <Button className={styles.cancelBtn} onClick={props.handleCancel} sx={{textTransform:'none', color: styles.secondaryBlue800, visibility: props.handleCancel !== undefined ?'visible':'hidden'}} disabled={props.loading}>Cancel</Button>
            {
              props.destructive ?
              <DestructiveButton onClick={props.onConfirm} loading={props.loading}>{props.buttonText?props.buttonText:'Ok'}</DestructiveButton>
              :
              <PrimaryButton onClick={props.onConfirm} loading={props.loading}>{props.buttonText?props.buttonText:'Ok'}</PrimaryButton>
            }
          </Stack>
        </Stack>
      </Dialog>
    )
  }
  interface ISuccessDialog {
    visible: boolean;
  
    title?: string;
    desc?: string|ReactNode;
    onConfirm: () => void;
    buttonText?: string;
  }
  export const SuccessDialog = (props: ISuccessDialog) => {
  
    return (
      <Dialog open={props.visible} onClose={() => { }}>
        <Stack className={styles.deleteDialogContent} sx={{ width: pxToRem(600) }}>
          {props.title?<h5>{props.title}</h5>:null}
          {props.desc ? <p>{props.desc}</p> : null}
        </Stack>
        <Stack className={styles.successDialogAction}>
          <Divider flexItem />
          <Stack sx={{alignItems:'flex-end', width: '100%'}}>
            <PrimaryButton onClick={props.onConfirm}>{props.buttonText?props.buttonText:'Ok'}</PrimaryButton>
          </Stack>
        </Stack>
      </Dialog>
    )
  }